var Base = require('_js/base'),
  ko = require('knockout');

function model(params) {
  self.course = params;
  $('.overview-page .accordion-single header').on('click', function() {
    $(this)
      .parent()
      .toggleClass('active');
  });
}

function OverviewPage() {
  this.init();
}

OverviewPage.prototype = new Base();

OverviewPage.prototype.init = function() {
  var $overviewPage = $('[data-calendar]');
  if ($overviewPage.get(0) !== undefined) {
    ko.applyBindings(
      new model({ overview: $overviewPage }),
      $overviewPage.get(0)
    );
  }
};

module.exports = OverviewPage;
